enum InvoiceLineItemDateFormat {
	'DD/MM/YYYY' = 'DD/MM/YYYY',
	'MM/DD/YYYY' = 'MM/DD/YYYY',
}

const invoiceLineItemDateFormats = Object.keys(InvoiceLineItemDateFormat)

export { invoiceLineItemDateFormats }
